<script setup lang="ts">
import { TheDrawerNav, TheNavbar, TheSnackbar } from '@/components/';
import { useMobileStore } from '@/store/mobile';
import { storeToRefs } from 'pinia';

const mobileStore = useMobileStore();
const { showMenu } = storeToRefs(mobileStore);
const { toggleMenu } = mobileStore;

const showDrawer = () => {
  toggleMenu(true);
};
</script>

<template>
  <NuxtLoadingIndicator color="#00A8B5" />
  <v-layout>
    <v-main>
      <TheNavbar @openDrawer="showDrawer" :show-burger-menu="true" />
      <NuxtPage :page-key="(route) => route.fullPath" />
      <TheSnackbar />
    </v-main>
    <TheDrawerNav />
  </v-layout>
</template>

<style lang="scss" scoped></style>
